import React from 'react';
import Icon from '../../../components/AppIcon';

const CompletionOverview = ({ batchData }) => {
  const {
    totalInvoices,
    successfulInvoices,
    failedInvoices,
    warningInvoices,
    processingTime,
    zatcaComplianceRate,
    batchId,
    completedAt
  } = batchData;

  const successRate = ((successfulInvoices / totalInvoices) * 100)?.toFixed(1);
  const failureRate = ((failedInvoices / totalInvoices) * 100)?.toFixed(1);

  return (
    <div className="bg-muted rounded-lg border border-border p-6 shadow-sm">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl font-semibold text-foreground mb-1">
            Batch Processing Complete
          </h2>
          <p className="text-sm text-muted-foreground">
            Batch ID: {batchId} • Completed at {new Date(completedAt)?.toLocaleString('en-GB')}
          </p>
        </div>
        <div className="flex items-center space-x-2">
          <Icon name="CheckCircle" size={24} color="var(--color-success)" strokeWidth={2} />
          <span className="text-lg font-semibold text-success">Complete</span>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <div className="bg-muted rounded-lg p-4">
          <div className="flex items-center justify-between mb-2">
            <Icon name="FileText" size={20} color="var(--color-text-secondary)" />
            <span className="text-2xl font-bold text-foreground">{totalInvoices}</span>
          </div>
          <p className="text-sm font-medium text-muted-foreground">Total Invoices</p>
        </div>

        <div className="bg-success/10 border border-success/20 rounded-lg p-4">
          <div className="flex items-center justify-between mb-2">
            <Icon name="CheckCircle" size={20} color="var(--color-success)" />
            <span className="text-2xl font-bold text-success">{successfulInvoices}</span>
          </div>
          <p className="text-sm font-medium text-success">Successful</p>
          <p className="text-xs text-success/80">{successRate}% success rate</p>
        </div>

        <div className="bg-error/10 border border-error/20 rounded-lg p-4">
          <div className="flex items-center justify-between mb-2">
            <Icon name="XCircle" size={20} color="var(--color-error)" />
            <span className="text-2xl font-bold text-error">{failedInvoices}</span>
          </div>
          <p className="text-sm font-medium text-error">Failed</p>
          <p className="text-xs text-error/80">{failureRate}% failure rate</p>
        </div>

        <div className="bg-warning/10 border border-warning/20 rounded-lg p-4">
          <div className="flex items-center justify-between mb-2">
            <Icon name="AlertTriangle" size={20} color="var(--color-warning)" />
            <span className="text-2xl font-bold text-warning">{warningInvoices}</span>
          </div>
          <p className="text-sm font-medium text-warning">Warnings</p>
          <p className="text-xs text-warning/80">Require attention</p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-muted rounded-lg p-4">
          <div className="flex items-center space-x-2 mb-3">
            <Icon name="Clock" size={18} color="var(--color-text-secondary)" />
            <h3 className="font-medium text-foreground">Processing Time</h3>
          </div>
          <p className="text-2xl font-bold text-foreground mb-1">{processingTime}</p>
          <p className="text-sm text-muted-foreground">Total batch duration</p>
        </div>

        <div className="bg-accent/10 border border-accent/20 rounded-lg p-4">
          <div className="flex items-center space-x-2 mb-3">
            <Icon name="Shield" size={18} color="var(--color-accent)" />
            <h3 className="font-medium text-accent">ZATCA Compliance</h3>
          </div>
          <p className="text-2xl font-bold text-accent mb-1">{zatcaComplianceRate}%</p>
          <p className="text-sm text-accent/80">Clearance rate achieved</p>
        </div>
      </div>
    </div>
  );
};

export default CompletionOverview;

